export default function queue() {
    var q = [];

    return {
        hasNext: function() {
            return q.length > 0;
        },
        add: function(item) {
            if (item) {
                q.push(item);
            }
        },
        next: function() {
            return q.shift();
        },
        flush: function() {
            q = [];
        }
    };
}
